import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { LearningModule } from '../../../amorg-common';
import { getLearningModulesPublic, getLearningModules } from '../../../api/learningClientApi';
import { CardButton } from '../../../designSystem/CardButton';
import { Flex, Grid } from '../../../designSystem/compositeComponents/FlexHelpers';
import { iconName, Icon } from '../../../designSystem/icons/Icons';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../designSystem/PageHeader';
import { H3 } from '../../../designSystem/typography/Heading';

type LearningModuleListProps = {
    isPublic?: boolean;
}

export function LearningModuleList (props:LearningModuleListProps): JSX.Element
{
    const [loading, setLoading] = React.useState(true);
    const [modules, setModules] = React.useState<LearningModule[]>([]);

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const moduleList = props.isPublic ? await getLearningModulesPublic() : await getLearningModules();
            moduleList.sort((a, b) => a.title.localeCompare(b.title));
            setModules(moduleList);
            setLoading(false);
        };
        getData();
    }, []);

    const navigate = useNavigate();

    const getIcon = (module: LearningModule): iconName => module.icon as iconName;

    return (
        <SingleColumnLayout
            noDivider
            contentContainer={
                <Flex flexDirection='column' gap={16}>

                    <LoadingPageOverlay loading={loading} />

                    <PageHeader 
                        headerStyle="secondary-gray"
                        headerIcon='school'
                        headerText='Opslagsværk' />

                    {!loading &&  (
                    <section>
                        {modules.length === 0 &&
                            <span>Der er ingen e-learning moduler tilgængelige</span>
                        }
                        {modules.length > 0 &&
                            <Grid gridTemplateColumns={2} gap={24}>
                                {modules.map(m =>
                                {
                                    return (
                                        <CardButton key={m.id} variant="outlined" onClick={ () => navigate(
                                            props.isPublic ? `/learning/public/${m.id}` : `/learning/${m.id}`)}>
                                            <Flex flexDirection='row' gap={16} alignItems='center'>
                                                <Icon name={getIcon(m)}  size='medium' color={"#f9423a"} />
                                                <Flex flexDirection='column' gap={8}>
                                                    <H3>{m.title}</H3>
                                                </Flex>
                                            </Flex>
                                        </CardButton>
                                    );
                                })}
                            </Grid>
                        }
                    </section>
                    )}
                </Flex>
            } />

    );
}
